import { routerReducer } from 'react-router-redux';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import auth from './auth';
import entities from './entities';
import i18n from './i18n';
import app from './app';
import users from './users';
import awards from './awards';
import info from './info';
import categories from './categories';
import works from './works';
import instagram from './instagram';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['i18n'],
  debug: false
};

export default persistCombineReducers(persistConfig, {
  router: routerReducer,
  auth,
  entities,
  i18n,
  app,
  users,
  awards,
  info,
  categories,
  works,
  instagram
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js